import { PresencasResponse } from 'api/Assessor/evento';

interface RelatorioState {
  agencias: Array<string>;
  cpfOrNome: string;
  texto: string;
  nucleos: Array<string>;
  page: number;
  size: number;
  loadingTotais: boolean;
  totais: PresencasResponse | null;
  needReloadTable: boolean;
}

type RelatorioActionTypes =
  | 'setFiltros'
  | 'setFiltrosGuest'
  | 'setPaginacao'
  | 'setLoadingTotais'
  | 'setTotais'
  | 'needReload';

interface RelatorioAction {
  type: RelatorioActionTypes;
  value: any;
}

export const relatorioInitialState: RelatorioState = {
  agencias: [],
  cpfOrNome: '',
  texto: '',
  nucleos: [],
  page: 1,
  size: 10,
  loadingTotais: false,
  totais: null,
  needReloadTable: false,
};

export const relatorioInitialState2 = {
  agencias: [],
  cpfOrNome: '',
  texto: '',
  nucleos: [],
  page: 1,
  size: 10,
};

export const relatorioReducer = (
  state: RelatorioState,
  action: RelatorioAction
): RelatorioState => {
  switch (action.type) {
    case 'setFiltros':
    case 'setFiltrosGuest':
    case 'setPaginacao':
      return { ...state, ...action.value };
    case 'setLoadingTotais':
      return { ...state, loadingTotais: action.value };
    case 'setTotais':
      return { ...state, totais: action.value };
    case 'needReload':
      return { ...state, needReloadTable: action.value };
    default:
      return state;
  }
};
